import {
    Box,
    FormControl,
    FormLabel,
    Select,
    Stack,
    Text,
    VStack,
} from '@chakra-ui/react';

import {
    descriptionStyling,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import { ocUsageTypes } from '../constants';

export default function UsageTypeField({
    darkMode,
    value,
    setFieldValue,
    handleFieldValueChange,
}) {
    const handleChange = (event) => {
        const nextValue = event.target.value;
        setFieldValue('usage', nextValue);
        handleFieldValueChange('usage', nextValue);
    };

    return (
        <FormControl isRequired sx={{ margin: '0 !important' }}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Usage Type
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Please select Usage Type for this order
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'flex-start',
                            paddingTop: '15px',
                        }}>
                        <VStack width="100%" alignItems="normal">
                            <Select
                                name="usage"
                                value={value || ''}
                                onChange={handleChange}
                                placeholder="Please select Usage Type"
                                height="40px"
                                minHeight="40px"
                                size="sm"
                                borderRadius="md"
                                borderColor={
                                    darkMode
                                        ? 'dark.tcap-borderGray'
                                        : 'gray.200'
                                }
                                backgroundColor={
                                    darkMode ? 'dark.tcap' : 'white'
                                }
                                color={darkMode ? 'dark.textDark' : 'inherit'}>
                                {ocUsageTypes.map((usage) => (
                                    <option
                                        key={usage.id}
                                        value={usage.id}
                                        style={
                                            darkMode
                                                ? {
                                                      background: '#2D3748',
                                                      color: '#F7FAFC',
                                                  }
                                                : {}
                                        }>
                                        {usage.displayName}
                                    </option>
                                ))}
                            </Select>
                        </VStack>
                    </Box>
                </Box>
            </Stack>
        </FormControl>
    );
}
